import React from 'react'

const PrimaryDivider = () => {
    return (
        <div className='h-[1px] bg-[#EFEFEF]' />
    )
}

export default PrimaryDivider